module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0134.jpg?v=6abb3279";